import { t } from 'i18next';

export const getTranslation = (key: string, options?: any): string => {
  return String(t(key, options));
};

export default getTranslation;
